import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-200 ease-[var(--spring-soft)] active:scale-[0.97] active:duration-100 active:ease-[var(--spring)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 disabled:active:scale-100 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--accent)] text-white shadow-sm hover:opacity-90",
        destructive:
          "bg-[var(--danger)] text-white shadow-sm hover:opacity-90",
        outline:
          "border border-[var(--glass-border-strong)] bg-[var(--glass-bg)] text-[var(--foreground)] hover:bg-[var(--glass-bg-hover)] backdrop-blur-md backdrop-saturate-150",
        secondary:
          "bg-[var(--glass-bg-hover)] text-[var(--foreground)] border border-[var(--glass-border)] hover:bg-[var(--glass-bg-active)]",
        ghost:
          "text-[var(--foreground-2)] hover:bg-[var(--glass-bg-hover)] hover:text-[var(--foreground)]",
        link:
          "text-[var(--accent)] underline-offset-4 hover:underline p-0 h-auto",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-lg px-3 text-xs",
        lg: "h-10 rounded-xl px-6",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
